import * as React from 'react';
import { PaginationProps } from 'antd/lib/pagination';
import { TableProps } from 'antd/lib/table';
import { Table } from 'antd';
import * as uuid from 'uuid';

export interface ICommonTable<T = {}> extends TableProps<T> {
  rowKey: string;
  /** 记录总数 */
  total?: number;
  /** 起始数 */
  offset?: number;
  /** 记录数 */
  limit?: number;
  /** 是否分页 true分页 false/undefined不分页 */
  showPagination?: boolean;
  /** 表格loading */
  loadingTable: boolean;

  selectedRowKeys?: string[] | number[];
}

export interface ICommonTableProps extends ICommonTable {
  /** 表格数据加载事件 */
  callback?(offset: number, limit: number): Promise<void>;
  /** 表格行选择回调事件 undefined不可选择 */
  cbSelectedRow?(selectedRowKeys: string[] | number[]): void;
  cbToggleOrdering?(ordering: string | undefined, offset: number, limit: number): void;
}

interface ICommonTableState {
  /** 分页设置 */
  pagination: PaginationProps;
  /** 选中的行 */
  selectedRowKeys: string[] | number[];
}

/**
 * ANT通用Table
 *
 * @class CommonTable
 * @extends {React.Component<ICommonTableProps, ICommonTableState>}
 */
class CommonTable extends React.Component<ICommonTableProps, ICommonTableState> {
  constructor(props: ICommonTableProps) {
    super(props);

    this.state = {
      pagination: {
        total: 0,
        current: 1,
        pageSize: 10,
      },
      selectedRowKeys: [],
    } as ICommonTableState;
  }

  componentDidMount() {}

  UNSAFE_componentWillReceiveProps(nextProps: ICommonTableProps) {
    // const { selectedRowKeys } = nextProps;
    // if (!!selectedRowKeys) {
    //   this.setState({
    //     selectedRowKeys,
    //   });
    // }
    this.patchData(nextProps);
  }

  // componentWillUpdate() {
  //   this.patchData();
  // }

  componentWillUnmount() {
    this.setState = () => {
      return;
    };
  }

  /**
   * 对传入的props进行处理
   * 1、分页
   * 2、表格Index
   * @memberof CommonTable
   */
  patchData = (nextProps: ICommonTableProps) => {
    const { total, dataSource, offset, limit, selectedRowKeys } = nextProps;
    const { pagination } = this.state;
    if (!!total) {
      pagination.total = total;
    }
    if (limit !== undefined && limit > 0) {
      pagination.current = (offset || 0) / limit + 1;
      pagination.pageSize = limit;
    }

    if (!!selectedRowKeys) {
      this.setState({
        selectedRowKeys,
        pagination,
      });
    } else {
      this.setState({
        pagination,
      });
    }

    if (!!dataSource) {
      for (let i = 0; i < dataSource.length; i++) {
        const data = dataSource[i] as any;
        // if (!data.uuid) {
        //   data.uuid = uuid.v4();
        // }
        data.index = !!pagination.pageSize ? i + 1 + (Number(pagination.current) - 1) * pagination.pageSize : i + 1;
      }
    }
  };

  handleSearch = async (offset: number = 0, limit: number = 10) => {
    if (!!this.props.callback) {
      await this.props.callback(offset, limit);
    }
  };

  handleTableOnChange = async (pagination: PaginationProps, filters: any, sorter: any) => {
    const pager: PaginationProps = { ...this.state.pagination };
    let ordering: undefined | string;
    pager.current = pagination.current || 1;
    pager.pageSize = pagination.pageSize || 10;

    this.setState({
        pagination: pager,
        selectedRowKeys: [],
    });

    if (!!sorter.order) {
        const isAscend = sorter.order === 'ascend' ? '' : '-';
        ordering = `${isAscend}${sorter.field}`;
    }

    if (!!this.props.cbSelectedRow) {
      this.props.cbSelectedRow([]);
    }

    if (this.props.cbToggleOrdering) {
        this.props.cbToggleOrdering(ordering, (Number(pager.current) - 1) * Number(pager.pageSize), pager.pageSize);
        return;
    }

    await this.handleSearch((Number(pager.current) - 1) * Number(pager.pageSize), pager.pageSize);
  };

  /**
   * Table 选中项发生变化时的回调
   *
   * @memberof CommonTable
   */
  onSelectChange = (selectedRowKeys: string[] | number[]) => {
    this.setState({ selectedRowKeys });
    if (!!this.props.cbSelectedRow) {
      this.props.cbSelectedRow(selectedRowKeys);
    }
  };

  render() {
    const rowSelection = {
      selectedRowKeys: this.state.selectedRowKeys,
      onChange: this.onSelectChange,
    };

    return (
      <Table
        // rowKey="uuid"
        {...this.props}
        rowSelection={!!this.props.cbSelectedRow ? rowSelection : undefined}
        pagination={!!this.props.showPagination ? this.state.pagination : false}
        // loading={this.props.loadingTable}
        // columns={this.props.columns}
        // dataSource={this.props.dataSource}
        // scroll={this.props.scroll}
        // components={this.props.components}
        // rowClassName={this.props.rowClassName}
        onChange={this.handleTableOnChange}
      />
    );
  }
}

export default CommonTable;



// WEBPACK FOOTER //
// ./src/components/common/CommonTable.tsx